module.exports = __webpack_public_path__ + "img/young_white_logo.f231d37d.png";